import { defHttp } from '/@/utils/http/axios';
import { RegisterParamsType } from '/#/obboarding';
import { userAccountType } from './model/account';
enum Api {
  ONBOARDING = '/ex-member/onboardings',
  // 新增子登陆账号
  SUBACCOUNT = '/member/login-accounts/sub/creation',
  // 更新子登陆账号
  SUBACCOUNT_UPDATE = '/member/login-accounts/sub/update',
  // 注销子登陆账号
  SUBACCOUNT_DELETE = '/member/login-accounts/sub/cancellation',
  // 下载文件
  DOWNLOAD_AGREEMENTS = '/ex-member/pdf/agreements',
  // 董事会文件列表授权邮箱集合
  BOARD_AUTHORIZED_EMAILS = '/member/members/authorised-people',
  // 删除子授权人账号
  DELETE_AUTHORIZED_PERSON = '/ex-member/info-modifications/sub-authorised-login-account/remove',
  // 移交超管账号
  TRANSFER_SUPER_ACCOUNT = '/ex-member/info-modifications/primary-authorised-login-account/transfer',
  // 可转移超管账号列表
  TRANSFER_SUPER_ACCOUNT_LIST = '/member/login-accounts/transfer/available',
  // 获取登录账号角色与权限
  LOGIN_ACCOUNT_ROLE_PERMISSION = '/member/login-accounts/role-menus',
}

/**
 * @description: Get
 */
export const addOnboardingsApi = (params?: RegisterParamsType) =>
  defHttp.post({ url: Api.ONBOARDING, params });

export function fetchOnboardingsApi() {
  return defHttp.get<RegisterParamsType>({ url: Api.ONBOARDING });
}
// 获取 董事会文件列表授权邮箱集合
export function fetchBoardAuthorizedEmailsApi() {
  return defHttp.get({ url: Api.BOARD_AUTHORIZED_EMAILS });
}
/**
 * 新增子登陆账号
 */
export const addSubAccountApi = (params?) => defHttp.post({ url: Api.SUBACCOUNT, params });

/**
 * 更新子登陆账号
 */
export const updateSubAccountApi = (params?) =>
  defHttp.post({ url: Api.SUBACCOUNT_UPDATE, params });

/**
 * 注销子登陆账号
 */
export const deleteSubAccountApi = (params: { subLoginAccountId: string }) =>
  defHttp.post({ url: Api.DELETE_AUTHORIZED_PERSON, params });

/**
 *
 * @param params 下载文件
 * @returns
 */
export const downloadFile = (params) => {
  return defHttp
    .post(
      { url: `${Api.DOWNLOAD_AGREEMENTS}?type=${params.type}`, params, responseType: 'blob' },
      {
        isTransformResponse: false,
      },
    )
    .then((data) => {
      return window.URL.createObjectURL(data);
    });
};
/**
 * [接口 移交超管账号](https://exmbr-dev1.microconnect.cc/ex-member/doc.html#/-ex-member-v3-api-docs/%E4%BC%9A%E5%91%98%E4%BF%A1%E6%81%AF%E4%BF%AE%E6%94%B9/transferPrimaryAuthorisedLoginAccount)
 */
export const transferSuperAccountApi = (params: { subLoginAccountId: string }) =>
  defHttp.post({ url: Api.TRANSFER_SUPER_ACCOUNT, params });

/**
 * [接口 可转移超管账号列表](https://exmt-dev1.microconnect.cc/member/doc.html#/-member-v3-api-docs/%E7%99%BB%E9%99%86%E8%B4%A6%E5%8F%B7/listTransferAvailable)
 */
export const transferSuperAccountListApi = () =>
  defHttp.get<userAccountType[]>({ url: Api.TRANSFER_SUPER_ACCOUNT_LIST });

/**
 * [接口 获取登录账号角色与权限](https://exmt-dev1.microconnect.cc/member/doc.html#/-member-v3-api-docs/%E7%99%BB%E9%99%86%E8%B4%A6%E5%8F%B7/getLoginAccountRoles)
 */
export const loginAccountRolePermissionApi = (params: { loginAccountId: string }) =>
  defHttp.get({ url: Api.LOGIN_ACCOUNT_ROLE_PERMISSION, params });
